import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-tab-layout',
  templateUrl: './tab-layout.component.html',
  styleUrl: './tab-layout.component.scss'
})
export class TabLayoutComponent implements OnInit{

  @Input({ required: true }) tabItems: TabItem[]
  @Input() isKiosk: boolean = false
  @Output() slug = new EventEmitter();

  activeIndex: number = 0
  activeSlug: any;

  ngOnInit() {
    this.activeIndex = 0
    this.activeSlug = this.tabItems[0]?.slug;
  }

  selectTab() {
    this.slug.emit(this.activeSlug)
  }

}

export interface TabItem {
  slug: any;
  title: string;
  count?: number;
  icon?: string;
  permissions?: string[]
}
